export class Urls {
    static get baseUrlAccountServer(): string {
        return process.env.NEXT_PUBLIC_ACCOUNT_SERVER_URL;
    }

    static get baseUrlBackendServer(): string {
        return process.env.NEXT_PUBLIC_BE_URL;
    }
}
